var map = {
	"./$pac.svg": 627,
	"./0xbtc.svg": 628,
	"./2give.svg": 629,
	"./aave.svg": 630,
	"./abt.svg": 631,
	"./act.svg": 632,
	"./actn.svg": 633,
	"./ada.svg": 634,
	"./add.svg": 635,
	"./adx.svg": 636,
	"./ae.svg": 637,
	"./aeon.svg": 638,
	"./aeur.svg": 639,
	"./agi.svg": 640,
	"./agrs.svg": 641,
	"./aion.svg": 642,
	"./algo.svg": 643,
	"./amb.svg": 644,
	"./amp.svg": 645,
	"./ampl.svg": 646,
	"./ankr.svg": 647,
	"./ant.svg": 648,
	"./apex.svg": 649,
	"./appc.svg": 650,
	"./ardr.svg": 651,
	"./arg.svg": 652,
	"./ark.svg": 653,
	"./arn.svg": 654,
	"./arnx.svg": 655,
	"./ary.svg": 656,
	"./ast.svg": 657,
	"./atm.svg": 658,
	"./atom.svg": 659,
	"./audr.svg": 660,
	"./auto.svg": 661,
	"./aywa.svg": 662,
	"./bab.svg": 663,
	"./bal.svg": 664,
	"./band.svg": 665,
	"./bat.svg": 666,
	"./bay.svg": 667,
	"./bcbc.svg": 668,
	"./bcc.svg": 669,
	"./bcd.svg": 670,
	"./bch.svg": 671,
	"./bcio.svg": 672,
	"./bcn.svg": 673,
	"./bco.svg": 674,
	"./bcpt.svg": 675,
	"./bdl.svg": 676,
	"./beam.svg": 677,
	"./bela.svg": 678,
	"./bix.svg": 679,
	"./blcn.svg": 680,
	"./blk.svg": 681,
	"./block.svg": 682,
	"./blz.svg": 683,
	"./bnb.svg": 684,
	"./bnt.svg": 685,
	"./bnty.svg": 686,
	"./booty.svg": 687,
	"./bos.svg": 688,
	"./bpt.svg": 689,
	"./bq.svg": 690,
	"./brd.svg": 691,
	"./bsd.svg": 692,
	"./bsv.svg": 693,
	"./btc.svg": 694,
	"./btcd.svg": 695,
	"./btch.svg": 696,
	"./btcp.svg": 697,
	"./btcz.svg": 698,
	"./btdx.svg": 699,
	"./btg.svg": 700,
	"./btm.svg": 701,
	"./bts.svg": 702,
	"./btt.svg": 703,
	"./btx.svg": 704,
	"./burst.svg": 705,
	"./bze.svg": 706,
	"./call.svg": 707,
	"./cc.svg": 708,
	"./cdn.svg": 709,
	"./cdt.svg": 710,
	"./cenz.svg": 711,
	"./chain.svg": 712,
	"./chat.svg": 713,
	"./chips.svg": 714,
	"./cix.svg": 715,
	"./clam.svg": 716,
	"./cloak.svg": 717,
	"./cmm.svg": 718,
	"./cmt.svg": 719,
	"./cnd.svg": 720,
	"./cnx.svg": 721,
	"./cny.svg": 722,
	"./cob.svg": 723,
	"./colx.svg": 724,
	"./comp.svg": 725,
	"./coqui.svg": 726,
	"./cred.svg": 727,
	"./crpt.svg": 728,
	"./crv.svg": 729,
	"./crw.svg": 730,
	"./cs.svg": 731,
	"./ctr.svg": 732,
	"./ctxc.svg": 733,
	"./cvc.svg": 734,
	"./d.svg": 735,
	"./dai.svg": 736,
	"./dash.svg": 737,
	"./dat.svg": 738,
	"./data.svg": 739,
	"./dbc.svg": 740,
	"./dcn.svg": 741,
	"./dcr.svg": 742,
	"./deez.svg": 743,
	"./dent.svg": 744,
	"./dew.svg": 745,
	"./dgb.svg": 746,
	"./dgd.svg": 747,
	"./dlt.svg": 748,
	"./dnt.svg": 749,
	"./dock.svg": 750,
	"./doge.svg": 751,
	"./dot.svg": 752,
	"./drgn.svg": 753,
	"./drop.svg": 754,
	"./dta.svg": 755,
	"./dth.svg": 756,
	"./dtr.svg": 757,
	"./ebst.svg": 758,
	"./eca.svg": 759,
	"./edg.svg": 760,
	"./edo.svg": 761,
	"./edoge.svg": 762,
	"./ela.svg": 763,
	"./elec.svg": 764,
	"./elf.svg": 765,
	"./elix.svg": 766,
	"./ella.svg": 767,
	"./emc.svg": 768,
	"./emc2.svg": 769,
	"./eng.svg": 770,
	"./enj.svg": 771,
	"./entrp.svg": 772,
	"./eon.svg": 773,
	"./eop.svg": 774,
	"./eos.svg": 775,
	"./eqli.svg": 776,
	"./equa.svg": 777,
	"./etc.svg": 778,
	"./eth.svg": 779,
	"./ethos.svg": 780,
	"./etn.svg": 781,
	"./etp.svg": 782,
	"./eur.svg": 783,
	"./evx.svg": 784,
	"./exmo.svg": 785,
	"./exp.svg": 786,
	"./fair.svg": 787,
	"./fct.svg": 788,
	"./fil.svg": 789,
	"./fjc.svg": 790,
	"./fldc.svg": 791,
	"./flo.svg": 792,
	"./fsn.svg": 793,
	"./ftc.svg": 794,
	"./fuel.svg": 795,
	"./fun.svg": 796,
	"./game.svg": 797,
	"./gas.svg": 798,
	"./gbp.svg": 799,
	"./gbx.svg": 800,
	"./gbyte.svg": 801,
	"./generic.svg": 802,
	"./gin.svg": 803,
	"./glxt.svg": 804,
	"./gmr.svg": 805,
	"./gno.svg": 806,
	"./gnt.svg": 807,
	"./gold.svg": 808,
	"./grc.svg": 809,
	"./grin.svg": 810,
	"./grs.svg": 811,
	"./grt.svg": 812,
	"./gsc.svg": 813,
	"./gto.svg": 814,
	"./gup.svg": 815,
	"./gusd.svg": 816,
	"./gvt.svg": 817,
	"./gxs.svg": 818,
	"./gzr.svg": 819,
	"./hight.svg": 820,
	"./hodl.svg": 821,
	"./hot.svg": 822,
	"./hpb.svg": 823,
	"./hsr.svg": 824,
	"./ht.svg": 825,
	"./html.svg": 826,
	"./huc.svg": 827,
	"./hush.svg": 828,
	"./icn.svg": 829,
	"./icx.svg": 830,
	"./ignis.svg": 831,
	"./ilk.svg": 832,
	"./ink.svg": 833,
	"./ins.svg": 834,
	"./ion.svg": 835,
	"./iop.svg": 836,
	"./iost.svg": 837,
	"./iotx.svg": 838,
	"./iq.svg": 839,
	"./itc.svg": 840,
	"./jnt.svg": 841,
	"./jpy.svg": 842,
	"./kcs.svg": 843,
	"./kin.svg": 844,
	"./klown.svg": 845,
	"./kmd.svg": 846,
	"./knc.svg": 847,
	"./krb.svg": 848,
	"./ksm.svg": 849,
	"./lbc.svg": 850,
	"./lend.svg": 851,
	"./leo.svg": 852,
	"./link.svg": 853,
	"./lkk.svg": 854,
	"./loom.svg": 855,
	"./lpt.svg": 856,
	"./lrc.svg": 857,
	"./lsk.svg": 858,
	"./ltc.svg": 859,
	"./lun.svg": 860,
	"./maid.svg": 861,
	"./mana.svg": 862,
	"./matic.svg": 863,
	"./mcap.svg": 864,
	"./mco.svg": 865,
	"./mda.svg": 866,
	"./mds.svg": 867,
	"./med.svg": 868,
	"./meetone.svg": 869,
	"./mft.svg": 870,
	"./miota.svg": 871,
	"./mith.svg": 872,
	"./mkr.svg": 873,
	"./mln.svg": 874,
	"./mnx.svg": 875,
	"./mnz.svg": 876,
	"./moac.svg": 877,
	"./mod.svg": 878,
	"./mona.svg": 879,
	"./msr.svg": 880,
	"./mth.svg": 881,
	"./mtl.svg": 882,
	"./music.svg": 883,
	"./mzc.svg": 884,
	"./nano.svg": 885,
	"./nas.svg": 886,
	"./nav.svg": 887,
	"./ncash.svg": 888,
	"./ndz.svg": 889,
	"./nebl.svg": 890,
	"./neo.svg": 891,
	"./neos.svg": 892,
	"./neu.svg": 893,
	"./nexo.svg": 894,
	"./ngc.svg": 895,
	"./nio.svg": 896,
	"./nkn.svg": 897,
	"./nlc2.svg": 898,
	"./nlg.svg": 899,
	"./nmc.svg": 900,
	"./nmr.svg": 901,
	"./npxs.svg": 902,
	"./nuls.svg": 903,
	"./nxs.svg": 904,
	"./nxt.svg": 905,
	"./oax.svg": 906,
	"./ok.svg": 907,
	"./omg.svg": 908,
	"./omni.svg": 909,
	"./ong.svg": 910,
	"./ont.svg": 911,
	"./oot.svg": 912,
	"./ost.svg": 913,
	"./ox.svg": 914,
	"./oxt.svg": 915,
	"./part.svg": 916,
	"./pasc.svg": 917,
	"./pasl.svg": 918,
	"./pax.svg": 919,
	"./pay.svg": 920,
	"./payx.svg": 921,
	"./pink.svg": 922,
	"./pirl.svg": 923,
	"./pivx.svg": 924,
	"./plr.svg": 925,
	"./poa.svg": 926,
	"./poe.svg": 927,
	"./polis.svg": 928,
	"./poly.svg": 929,
	"./pot.svg": 930,
	"./powr.svg": 931,
	"./ppc.svg": 932,
	"./ppp.svg": 933,
	"./ppt.svg": 934,
	"./pre.svg": 935,
	"./prl.svg": 936,
	"./pungo.svg": 937,
	"./pura.svg": 938,
	"./qash.svg": 939,
	"./qiwi.svg": 940,
	"./qlc.svg": 941,
	"./qrl.svg": 942,
	"./qsp.svg": 943,
	"./qtum.svg": 944,
	"./r.svg": 945,
	"./rads.svg": 946,
	"./rap.svg": 947,
	"./rcn.svg": 948,
	"./rdd.svg": 949,
	"./rdn.svg": 950,
	"./ren.svg": 951,
	"./rep.svg": 952,
	"./repv2.svg": 953,
	"./req.svg": 954,
	"./rhoc.svg": 955,
	"./ric.svg": 956,
	"./rise.svg": 957,
	"./rlc.svg": 958,
	"./rpx.svg": 959,
	"./rub.svg": 960,
	"./rvn.svg": 961,
	"./ryo.svg": 962,
	"./safe.svg": 963,
	"./sai.svg": 964,
	"./salt.svg": 965,
	"./san.svg": 966,
	"./sbd.svg": 967,
	"./sberbank.svg": 968,
	"./sc.svg": 969,
	"./shift.svg": 970,
	"./sib.svg": 971,
	"./sin.svg": 972,
	"./sky.svg": 973,
	"./slr.svg": 974,
	"./sls.svg": 975,
	"./smart.svg": 976,
	"./sngls.svg": 977,
	"./snm.svg": 978,
	"./snt.svg": 979,
	"./snx.svg": 980,
	"./soc.svg": 981,
	"./sol.svg": 982,
	"./spank.svg": 983,
	"./sphtx.svg": 984,
	"./srn.svg": 985,
	"./stak.svg": 986,
	"./start.svg": 987,
	"./steem.svg": 988,
	"./storj.svg": 989,
	"./storm.svg": 990,
	"./stox.svg": 991,
	"./stq.svg": 992,
	"./strat.svg": 993,
	"./stx.svg": 994,
	"./sub.svg": 995,
	"./sumo.svg": 996,
	"./sushi.svg": 997,
	"./sys.svg": 998,
	"./taas.svg": 999,
	"./tau.svg": 1000,
	"./tbx.svg": 1001,
	"./tel.svg": 1002,
	"./ten.svg": 1003,
	"./tern.svg": 1004,
	"./tgch.svg": 1005,
	"./theta.svg": 1006,
	"./tix.svg": 1007,
	"./tkn.svg": 1008,
	"./tks.svg": 1009,
	"./tnb.svg": 1010,
	"./tnc.svg": 1011,
	"./tnt.svg": 1012,
	"./tomo.svg": 1013,
	"./tpay.svg": 1014,
	"./trig.svg": 1015,
	"./trtl.svg": 1016,
	"./trx.svg": 1017,
	"./tusd.svg": 1018,
	"./tzc.svg": 1019,
	"./ubq.svg": 1020,
	"./uma.svg": 1021,
	"./uni.svg": 1022,
	"./unity.svg": 1023,
	"./usd.svg": 1024,
	"./usdc.svg": 1025,
	"./usdt.svg": 1026,
	"./utk.svg": 1027,
	"./veri.svg": 1028,
	"./vet.svg": 1029,
	"./via.svg": 1030,
	"./vib.svg": 1031,
	"./vibe.svg": 1032,
	"./vivo.svg": 1033,
	"./vrc.svg": 1034,
	"./vrsc.svg": 1035,
	"./vtc.svg": 1036,
	"./vtho.svg": 1037,
	"./wabi.svg": 1038,
	"./wan.svg": 1039,
	"./waves.svg": 1040,
	"./wax.svg": 1041,
	"./wbtc.svg": 1042,
	"./wgr.svg": 1043,
	"./wicc.svg": 1044,
	"./wings.svg": 1045,
	"./wpr.svg": 1046,
	"./wtc.svg": 1047,
	"./x.svg": 1048,
	"./xas.svg": 1049,
	"./xbc.svg": 1050,
	"./xbp.svg": 1051,
	"./xby.svg": 1052,
	"./xcp.svg": 1053,
	"./xdn.svg": 1054,
	"./xem.svg": 1055,
	"./xin.svg": 1056,
	"./xlm.svg": 1057,
	"./xmcc.svg": 1058,
	"./xmg.svg": 1059,
	"./xmo.svg": 1060,
	"./xmr.svg": 1061,
	"./xmy.svg": 1062,
	"./xp.svg": 1063,
	"./xpa.svg": 1064,
	"./xpm.svg": 1065,
	"./xrp.svg": 1066,
	"./xsg.svg": 1067,
	"./xtz.svg": 1068,
	"./xuc.svg": 1069,
	"./xvc.svg": 1070,
	"./xvg.svg": 1071,
	"./xzc.svg": 1072,
	"./yfi.svg": 1073,
	"./yoyow.svg": 1074,
	"./zcl.svg": 1075,
	"./zec.svg": 1076,
	"./zel.svg": 1077,
	"./zen.svg": 1078,
	"./zest.svg": 1079,
	"./zil.svg": 1080,
	"./zilla.svg": 1081,
	"./zrx.svg": 1082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 626;